/* Prime Outlet · Ficha de producto (oct 2026, v13)
   1) Fecha de entrega con selector de ubigeo + detección automática de ubicación (v13)
      v13.2: 1 día hábil de preparación y luego (lun–sáb): Lima 1–2 días, resto del país 2–4 días
   2) Cotización: línea discreta con 1 unidad, recuadro con 2 o más
   3) Cabecera: botón Ubicación, franja móvil (v13) y saludo de cuenta
   4) Fila Cantidad + Agregar al carrito (v12)
   5) Cuadrícula de características: botón Comparar y enlace a la ficha completa (v12)
*/
(function () {
  'use strict';

  /* ---------- 1. Fecha de entrega ---------- */
  var HOL = ['2026-01-01','2026-04-02','2026-04-03','2026-05-01','2026-06-07','2026-06-29','2026-07-23','2026-07-28','2026-07-29','2026-08-06','2026-08-30','2026-10-08','2026-11-01','2026-12-08','2026-12-09','2026-12-25',
             '2027-01-01','2027-03-25','2027-03-26','2027-05-01','2027-06-07','2027-06-29','2027-07-23','2027-07-28','2027-07-29','2027-08-06','2027-08-30','2027-10-08','2027-11-01','2027-12-08','2027-12-09','2027-12-25'];
  var DIAS = ['dom','lun','mar','mié','jue','vie','sáb'];
  var MES = ['ene','feb','mar','abr','may','jun','jul','ago','set','oct','nov','dic'];
  var LS_KEY = 'po_ubicacion_v1';          /* ubicación elegida por el cliente */
  var AUTO_KEY = 'po_ubicacion_auto_v1';   /* ubicación detectada por IP (caché) */
  var AUTO_TTL = 7 * 864e5, AUTO_TTL_FALLO = 864e5;

  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function habil(d) { return d.getDay() !== 0 && HOL.indexOf(iso(d)) < 0; }
  function sig(d) { var n = new Date(d); n.setDate(n.getDate() + 1); return n; }
  function sumarHabiles(d, k) { var x = new Date(d), c = 0; while (c < k) { x = sig(x); if (habil(x)) c++; } return x; }
  function limaHora() {
    /* hora actual en Lima (UTC-5) aunque el cliente esté en otra zona */
    var now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() - 300) * 60000);
  }
  var PREPARACION = 1;   /* días hábiles de preparación (proveedor + revisión de pago) */
  /* Despacho = día de compra (hora de Lima) + preparación; solo cuentan lun–sáb no feriados */
  function fechaDespacho() {
    var now = limaHora();
    return sumarHabiles(new Date(now.getFullYear(), now.getMonth(), now.getDate()), PREPARACION);
  }
  function fmt(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MES[d.getMonth()]; }
  function rangoTexto(a, b) {
    if (iso(a) === iso(b)) return 'Llega el <strong>' + fmt(a) + '</strong>';
    var ini = a.getMonth() === b.getMonth() ? DIAS[a.getDay()] + ' ' + a.getDate() : fmt(a);
    return 'Llega entre el <strong>' + ini + '</strong> y el <strong>' + fmt(b) + '</strong>';
  }
  function zona(u) {
    var lima = u.prov === '1501' || u.dep === '07';
    return { lima: lima, capital: String(u.dist).slice(4) === '01' };
  }
  function transito(u) {
    var z = zona(u);
    if (z.lima) return [1, 2];   /* Lima Metropolitana y Callao */
    return [2, 4];               /* resto del país, domicilio o agencia */
  }
  function calcular(u) {
    var t = transito(u), sale = fechaDespacho();
    return { a: sumarHabiles(sale, t[0]), b: sumarHabiles(sale, t[1]) };
  }
  function leer() { try { return JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) { return null; } }
  function guardar(u) { try { localStorage.setItem(LS_KEY, JSON.stringify(u)); } catch (e) {} }

  var DATA = null, dataPromise = null;
  function titulo(s) {
    s = String(s || '').toLowerCase().replace(/(^|[\s\-\(])([a-záéíóúñü])/g, function (m, a, b) { return a + b.toUpperCase(); });
    return s.replace(/ (De|Del|La|Las|Los|Y|El) /g, function (m) { return m.toLowerCase(); });
  }
  function getJSON(x) { return fetch(x).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function ubigeoUrls() {
    var m = document.querySelector('[data-po-entrega-modal]');
    return m ? m.getAttribute('data-ubigeo-url').split('|') : null;
  }
  function cargarData() {
    if (DATA) return Promise.resolve(DATA);
    if (!dataPromise) {
      var u = ubigeoUrls();
      if (!u) return Promise.reject(new Error('sin modal'));
      dataPromise = Promise.all([getJSON(u[0]), getJSON(u[1]), getJSON(u[2])]).then(function (r) {
        DATA = {
          d: r[0].ubigeo_departamentos.map(function (x) { return [x.ubigeo, titulo(x.departamento)]; }),
          p: r[1].ubigeo_provincias.map(function (x) { return [x.ubigeo, titulo(x.provincia)]; }),
          t: r[2].ubigeo_distritos.map(function (x) { return [x.ubigeo, titulo(x.distrito)]; })
        };
        return DATA;
      }).catch(function (e) { dataPromise = null; throw e; });
    }
    return dataPromise;
  }
  function nombre(list, code) { for (var i = 0; i < list.length; i++) if (list[i][0] === code) return list[i][1]; return ''; }

  /* ---------- Detección automática de ubicación ----------
     Prioridad: 1) lo que eligió el cliente  2) dirección guardada de su cuenta
                3) departamento por IP (se asume la capital)  4) sin ubicación (texto neutro)
     La ubicación automática NO se guarda como elección del cliente. */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/^(region|departamento|provincia|province|department)( de)?\s+/, '').replace(/\s+(region|province|department)$/, '').trim();
  }
  var DEP_ISO = { AMA:'01', ANC:'02', APU:'03', ARE:'04', AYA:'05', CAJ:'06', CAL:'07', CUS:'08', HUV:'09', HUC:'10', ICA:'11', JUN:'12', LAL:'13', LAM:'14', LIM:'15', LMA:'15', LOR:'16', MDD:'17', MOQ:'18', PAS:'19', PIU:'20', PUN:'21', SAM:'22', TAC:'23', TUM:'24', UCA:'25' };
  var DEP_NOM = { 'amazonas':'01', 'ancash':'02', 'apurimac':'03', 'arequipa':'04', 'ayacucho':'05', 'cajamarca':'06', 'callao':'07', 'el callao':'07', 'cusco':'08', 'cuzco':'08', 'huancavelica':'09', 'huanuco':'10', 'ica':'11', 'junin':'12', 'la libertad':'13', 'lambayeque':'14', 'lima':'15', 'lima metropolitana':'15', 'loreto':'16', 'madre de dios':'17', 'moquegua':'18', 'pasco':'19', 'piura':'20', 'puno':'21', 'san martin':'22', 'tacna':'23', 'tumbes':'24', 'ucayali':'25' };
  /* Capital de cada departamento: [ciudad para mostrar, departamento]; ubigeo = dep + '01' + '01' */
  var CAPITAL = { '01':['Chachapoyas','Amazonas'], '02':['Huaraz','Áncash'], '03':['Abancay','Apurímac'], '04':['Arequipa','Arequipa'], '05':['Ayacucho','Ayacucho'], '06':['Cajamarca','Cajamarca'], '07':['Callao','Callao'], '08':['Cusco','Cusco'], '09':['Huancavelica','Huancavelica'], '10':['Huánuco','Huánuco'], '11':['Ica','Ica'], '12':['Huancayo','Junín'], '13':['Trujillo','La Libertad'], '14':['Chiclayo','Lambayeque'], '15':['Lima','Lima'], '16':['Iquitos','Loreto'], '17':['Puerto Maldonado','Madre de Dios'], '18':['Moquegua','Moquegua'], '19':['Cerro de Pasco','Pasco'], '20':['Piura','Piura'], '21':['Puno','Puno'], '22':['Moyobamba','San Martín'], '23':['Tacna','Tacna'], '24':['Tumbes','Tumbes'], '25':['Pucallpa','Ucayali'] };

  function depDesde(codigo, nombreReg) {
    var c = String(codigo || '').toUpperCase().replace(/^PE-/, '');
    if (DEP_ISO[c]) return DEP_ISO[c];
    var n = norm(nombreReg);
    if (DEP_NOM[n]) return DEP_NOM[n];
    for (var k in DEP_NOM) if (n && n.indexOf(k) >= 0) return DEP_NOM[k];
    return null;
  }
  function ubicCapital(dep, origen) {
    var c = CAPITAL[dep];
    if (!c) return null;
    return { dep: dep, prov: dep + '01', dist: dep + '0101', modo: 'home', etiqueta: c[0] + ', ' + c[1], auto: origen };
  }
  function conTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  /* 2) Dirección guardada del cliente con sesión iniciada */
  function desdeCliente() {
    var el = document.querySelector('[data-po-cliente-dir]');
    if (!el || (el.getAttribute('data-pais') || '').toUpperCase() !== 'PE') return Promise.resolve(null);
    var dep = depDesde(el.getAttribute('data-prov-code'), el.getAttribute('data-prov'));
    if (!dep) return Promise.resolve(null);
    var base = ubicCapital(dep, 'cliente');
    var ciudad = norm(el.getAttribute('data-ciudad'));
    var urls = ubigeoUrls();
    if (!ciudad || !urls) return Promise.resolve(base);
    /* Si la ciudad coincide con una provincia del departamento, usamos esa provincia (archivo liviano, ~18 KB) */
    return conTimeout(getJSON(urls[1]), 4000).then(function (r) {
      var ps = r.ubigeo_provincias.filter(function (x) { return String(x.ubigeo).slice(0, 2) === dep; });
      for (var i = 0; i < ps.length; i++) {
        if (norm(ps[i].provincia) === ciudad) {
          var prov = String(ps[i].ubigeo), nom = titulo(ps[i].provincia);
          return { dep: dep, prov: prov, dist: prov + '01', modo: 'home', etiqueta: nom + ', ' + CAPITAL[dep][1], auto: 'cliente' };
        }
      }
      return base;
    }).catch(function () { return base; });
  }

  /* 3) Departamento por IP (servicios gratuitos por HTTPS; resultado en caché 7 días) */
  function leerAuto() {
    try {
      var a = JSON.parse(localStorage.getItem(AUTO_KEY));
      if (a && Date.now() - a.t < (a.u ? AUTO_TTL : AUTO_TTL_FALLO)) return a;
    } catch (e) {}
    return null;
  }
  function guardarAuto(u) { try { localStorage.setItem(AUTO_KEY, JSON.stringify({ u: u, t: Date.now() })); } catch (e) {} }
  function consultarIP() {
    var fuentes = [
      function () { return getJSON('https://get.geojs.io/v1/ip/geo.json').then(function (j) { return { pais: j.country_code, cod: '', reg: j.region }; }); },
      function () { return getJSON('https://ipapi.co/json/').then(function (j) { return { pais: j.country_code, cod: j.region_code, reg: j.region }; }); }
    ];
    var i = 0;
    function intentar() {
      if (i >= fuentes.length) return Promise.reject(new Error('sin respuesta'));
      return conTimeout(fuentes[i++](), 3500).catch(intentar);
    }
    return intentar();
  }
  function desdeIP() {
    var c = leerAuto();
    if (c) return Promise.resolve(c.u);
    return consultarIP().then(function (r) {
      var u = null;
      if (String(r.pais).toUpperCase() === 'PE') { var dep = depDesde(r.cod, r.reg); if (dep) u = ubicCapital(dep, 'ip'); }
      guardarAuto(u);
      return u;
    }).catch(function () { guardarAuto(null); return null; });
  }

  function detectar() {
    var s = leer();
    if (s) return Promise.resolve(s);
    return desdeCliente().then(function (u) { return u || desdeIP(); });
  }

  /* ---------- Selector de ubicación global (cabecera + ficha) ---------- */
  var U = leer();                 /* null = todavía sin ubicación */
  var DETECTANDO = !U;
  var DEFECTO = { dep: '15', prov: '1501', dist: '150101', modo: 'home', etiqueta: 'Lima, Lima' };
  var modalListo = false, tmp = null, M = {};

  function avisar() { document.dispatchEvent(new CustomEvent('po:ubicacion', { detail: U })); }

  function opciones(sel, list, val) {
    sel.innerHTML = list.map(function (x) { return '<option value="' + x[0] + '"' + (x[0] === val ? ' selected' : '') + '>' + x[1] + '</option>'; }).join('');
  }
  function llenarProv() {
    var ps = DATA.p.filter(function (x) { return x[0].slice(0, 2) === tmp.dep; });
    if (!ps.some(function (x) { return x[0] === tmp.prov; })) tmp.prov = ps.length ? ps[0][0] : '';
    opciones(M.prov, ps, tmp.prov);
    llenarDist();
  }
  function llenarDist() {
    var ds = DATA.t.filter(function (x) { return x[0].slice(0, 4) === tmp.prov; });
    if (!ds.some(function (x) { return x[0] === tmp.dist; })) tmp.dist = ds.length ? ds[0][0] : '';
    opciones(M.dist, ds, tmp.dist);
    pintarModal();
  }
  function pintarModal() {
    var z = zona(tmp);
    var dist = nombre(DATA.t, tmp.dist), prov = nombre(DATA.p, tmp.prov);
    M.hA.textContent = z.lima ? 'Agencia más cercana · 1 a 2 días' : (z.capital ? 'En ' + dist + ' · 2 a 4 días' : 'En la agencia de ' + prov + ' · 2 a 4 días');
    M.hH.textContent = z.lima ? 'A tu dirección · 1 a 2 días' : 'A tu dirección · 2 a 4 días';
    M.modos.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-po-modo') === tmp.modo ? 'true' : 'false'); });
    var r = calcular(tmp);
    var nota = z.lima ? 'Lima Metropolitana y Callao.' : (z.capital ? 'Capital de provincia.' : 'Distrito fuera de la capital: el envío a domicilio está sujeto a cobertura del courier.');
    M.res.innerHTML = rangoTexto(r.a, r.b) + '<small>' + (tmp.modo === 'agency' ? 'Recojo en agencia Shalom' : 'Envío a domicilio') + ' · ' + dist + ', ' + prov + ', ' + nombre(DATA.d, tmp.dep) + ' · ' + nota + '</small>';
  }
  function prepararModal(modal) {
    if (modalListo) return;
    modalListo = true;
    M = { el: modal, dep: modal.querySelector('[data-po-dep]'), prov: modal.querySelector('[data-po-prov]'), dist: modal.querySelector('[data-po-dist]'),
          modos: modal.querySelectorAll('[data-po-modo]'), res: modal.querySelector('[data-po-res]'),
          hA: modal.querySelector('[data-po-hint-agency]'), hH: modal.querySelector('[data-po-hint-home]') };
    M.dep.addEventListener('change', function () { tmp.dep = M.dep.value; llenarProv(); });
    M.prov.addEventListener('change', function () { tmp.prov = M.prov.value; llenarDist(); });
    M.dist.addEventListener('change', function () { tmp.dist = M.dist.value; pintarModal(); });
    M.modos.forEach(function (b) { b.addEventListener('click', function () { tmp.modo = b.getAttribute('data-po-modo'); pintarModal(); }); });
    modal.addEventListener('close', function () {
      if (modal.returnValue === 'ok' && tmp) {
        U = { dep: tmp.dep, prov: tmp.prov, dist: tmp.dist, modo: tmp.modo, etiqueta: nombre(DATA.t, tmp.dist) + ', ' + nombre(DATA.p, tmp.prov) };
        guardar(U);
        DETECTANDO = false;
        avisar();
      }
    });
  }
  function abrirUbicacion() {
    var modal = document.querySelector('[data-po-entrega-modal]');
    if (!modal) return;
    prepararModal(modal);
    cargarData().then(function () {
      var base = U || DEFECTO;
      tmp = { dep: base.dep, prov: base.prov, dist: base.dist, modo: base.modo || 'home' };
      opciones(M.dep, DATA.d, tmp.dep);
      llenarProv();
      modal.returnValue = '';
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
    }).catch(function () { alert('No pudimos cargar las ubicaciones. Intenta de nuevo.'); });
  }
  window.poAbrirUbicacion = abrirUbicacion;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-po-ubic-abrir]');
    if (b) { e.preventDefault(); abrirUbicacion(); }
  });

  function ciudad() { return U ? String(U.etiqueta || '').split(',')[0] : ''; }

  function initEntrega(box) {
    var txt = box.querySelector('[data-po-entrega-texto]');
    var lugar = box.querySelector('[data-po-entrega-lugar]');
    var cambiar = box.querySelector('[data-po-ubic-abrir]');
    var sep = box.querySelector('[data-po-entrega-sep]');
    var liq = box.hasAttribute('data-po-liq');   /* liquidación: siempre recojo en agencia Shalom */
    function pintarLinea() {
      if (!U) {
        if (DETECTANDO) { txt.textContent = 'Calculando fecha de entrega…'; return; }
        txt.innerHTML = 'Elige tu distrito para ver <strong>cuándo llega</strong>';
        lugar.textContent = '';
        if (sep) sep.hidden = true;
        cambiar.textContent = 'Elegir ubicación';
        return;
      }
      var u = liq ? { dep: U.dep, prov: U.prov, dist: U.dist, modo: 'agency' } : U;
      /* v12: la línea muestra solo el plazo; la modalidad se ve en el selector */
      var r = calcular(u);
      txt.innerHTML = rangoTexto(r.a, r.b);
      lugar.textContent = U.etiqueta || '';
      if (sep) sep.hidden = false;
      cambiar.textContent = U.auto ? '¿No es aquí? Cambiar' : 'Cambiar ubicación';
    }
    pintarLinea();
    document.addEventListener('po:ubicacion', pintarLinea);
  }

  /* ---------- Cabecera: botón Ubicación + franja móvil + saludo de cuenta ---------- */
  function initHeader() {
    var icons = document.querySelector('.header__icons');
    var tpl = document.querySelector('[data-po-hdr-tpl]');
    if (icons && tpl && !icons.querySelector('.po-hdr-ubic')) {
      var cuenta = icons.querySelector('.header__icon--account');
      var btn = tpl.content.firstElementChild.cloneNode(true);
      var lugar = btn.querySelector('[data-po-hdr-lugar]');
      var accion = btn.querySelector('[data-po-hdr-accion]');
      var pintar = function () {
        lugar.textContent = U ? 'Enviar a ' + ciudad() : 'Enviar a';
        if (accion) accion.textContent = U ? 'Ubicación' : 'Elegir ubicación';
      };
      pintar();
      document.addEventListener('po:ubicacion', pintar);
      if (cuenta) icons.insertBefore(btn, cuenta); else icons.insertBefore(btn, icons.querySelector('.header__icon--cart'));
      var saludo = document.querySelector('[data-po-hdr-cuenta]');
      if (cuenta && saludo && !icons.querySelector('.po-hdr-hola')) {
        /* shopify-account usa shadow DOM: el saludo va en un contenedor junto al icono */
        var w = document.createElement('div');
        w.className = 'po-hdr-cuenta';
        cuenta.parentNode.insertBefore(w, cuenta);
        w.appendChild(cuenta);
        var s = document.createElement('span');
        s.className = 'po-hdr-hola';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = saludo.getAttribute('data-po-hdr-cuenta');
        s.addEventListener('click', function () { var b = cuenta.shadowRoot && cuenta.shadowRoot.querySelector('button,a'); (b || cuenta).click(); });
        w.appendChild(s);
      }
    }
    /* Franja móvil "Enviar a …" bajo la cabecera */
    var franja = document.querySelector('[data-po-franja-txt]');
    if (franja) {
      var pintarFranja = function () {
        franja.innerHTML = U ? 'Enviar a <b>' + String(U.etiqueta || '').replace(/</g, '&lt;') + '</b>' : 'Elige tu ubicación para ver <b>cuándo llega</b>';
      };
      pintarFranja();
      document.addEventListener('po:ubicacion', pintarFranja);
    }
  }

  /* ---------- 2. Cotización según cantidad ---------- */
  function initCotizar(box) {
    var form = box.closest('.product__info-container') || document;
    var linea = box.querySelector('[data-po-cotizar-linea]');
    var caja = box.querySelector('[data-po-cotizar-caja]');
    var qtyLbl = box.querySelector('[data-po-qty]');
    var wa = box.getAttribute('data-wa'), waTxt = box.getAttribute('data-wa-text');

    function variantId() {
      var inp = form.querySelector('form[action*="/cart/add"] [name="id"]');
      return (inp && inp.value) || box.getAttribute('data-variant');
    }
    function qty() {
      var q = form.querySelector('input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }
    function actualizar() {
      var n = qty();
      linea.hidden = n >= 2;
      caja.hidden = n < 2;
      if (qtyLbl) qtyLbl.textContent = n;
      box.querySelectorAll('[data-po-wa-link]').forEach(function (a) {
        a.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(waTxt + ' ' + n);
      });
    }
    form.addEventListener('change', actualizar);
    form.addEventListener('input', actualizar);
    form.addEventListener('click', function (e) { if (e.target.closest('.quantity__button')) setTimeout(actualizar, 30); });
    actualizar();

    box.querySelectorAll('[data-po-cotizar-pdf]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId()), quantity: qty() }] })
        }).then(function () { window.location.href = a.getAttribute('href'); })
          .catch(function () { window.location.href = a.getAttribute('href'); });
      });
    });
  }

  /* ---------- 5. Botón Comparar junto a "Características principales" ---------- */
  function initComparar() {
    document.querySelectorAll('[data-po-sg-head], .po-chips').forEach(function (row) {
      var root = row.closest('.product__info-container') || document;
      var t = root.querySelector('.po-cmp-toggle--product');
      if (t && !row.contains(t)) row.appendChild(t);
    });
  }
  /* Enlace "Ver todas las especificaciones": abre el acordeón y baja hasta él */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-po-sg-full]');
    if (!a) return;
    var d = document.getElementById((a.getAttribute('href') || '').slice(1));
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- 4. Cantidad a la izquierda y Agregar al carrito a la derecha ----------
     El input de cantidad usa form="product-form-…", así que moverlo dentro de la fila
     de botones no altera el envío del formulario. */
  function initBuyRow() {
    document.querySelectorAll('.product__info-container').forEach(function (info) {
      var qty = info.querySelector('.product-form__quantity');
      var btns = info.querySelector('product-form .product-form__buttons');
      if (!qty || !btns) return;
      if (qty.parentNode !== btns) btns.insertBefore(qty, btns.firstChild);
      btns.classList.add('po-buyrow');
    });
  }
  function vigilarBuyRow() {
    /* Si el tema vuelve a pintar la sección (cambio de variante), se rearma la fila */
    var info = document.querySelector('.product__info-container');
    if (!info || !window.MutationObserver) return;
    var pend = false;
    new MutationObserver(function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; initBuyRow(); });
    }).observe(info.parentNode || info, { childList: true, subtree: true });
  }

  function init() {
    initHeader();
    initBuyRow();
    vigilarBuyRow();
    initComparar();
    document.querySelectorAll('[data-po-entrega]').forEach(initEntrega);
    document.querySelectorAll('[data-po-cotizar]').forEach(initCotizar);
    if (DETECTANDO) {
      detectar().then(function (u) {
        if (!leer()) U = u;   /* si el cliente eligió mientras tanto, se respeta su elección */
        DETECTANDO = false;
        avisar();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
